import { defineStore } from 'pinia'
import { api } from '@/lib/api'
import { createRefreshQueue } from '@/lib/refreshQueue'
import { useTicketsStore } from '@/stores/tickets'

const refreshers = new WeakMap()

export const useBoardStore = defineStore('board', {
  // `loaded` separa cold load (sem dado, mostra spinner) de refresh (dado quente
  // em cache, revalida em silêncio). Pinia é singleton: ao remontar o KanbanPage
  // como fundo do modal, os tickets continuam aqui — não há motivo pra piscar.
  state: () => ({ columns: [], tickets: [], loading: false, loaded: false, switching: false, scrollLeft: 0, columnScroll: {} }),
  actions: {
    async fetch() {
      if (!refreshers.has(this)) {
        refreshers.set(this, createRefreshQueue(async () => {
          const res = await api(`/api/board?view=${useTicketsStore().view}`)
          if (!res.ok) throw new Error('Falha ao carregar o board')
          return res.json()
        }, data => {
          this.columns = data.columns
          this.tickets = data.tickets
          this.loaded = true
        }))
      }
      this.loading = true
      try {
        await refreshers.get(this)()
      } finally {
        this.loading = false
      }
    },

    // Mover card = aplicar mudanças (status, etc.). Em falha, recarrega.
    async moveTicket(ticketId, changes) {
      const res = await api(`/api/tickets/${ticketId}`, {
        method: 'PATCH',
        body: { ticket: changes },
      })
      if (!res.ok) {
        await this.fetch()
        return false
      }
      await this.fetch()
      return true
    },

    clearNews(id) {
      const card = this.tickets.find(ticket => ticket.id === id)
      if (card) card.news = null
    },

    // Realtime: upsert do card (normaliza account/assignee p/ o shape do board).
    applyRealtime(ticket) {
      const card = {
        ...ticket,
        account: ticket.account?.name,
        assignee: ticket.assignee?.name,
      }
      const idx = this.tickets.findIndex(t => t.id === ticket.id)
      this.tickets =
        idx >= 0
          ? this.tickets.map((t, i) => (i === idx ? { ...t, ...card } : t))
          : [...this.tickets, card]
    },
  },
})
